import { trpc } from '@/lib/trpc';
import useProductStore from '@/stores/productStore';

const ReviewCategory = () => {
  const { data: allCategories } = trpc.product.categories.useQuery();
  const categories = useProductStore(d => d.categories || []);

  return (
    <div className='flex flex-col'>
      {allCategories
        ?.filter((item: { label: string; value: string }) => categories.includes(String(item.value)))
        .map((category: { label: string; value: string }, i: number) => (
          <span key={i}>{category.label}</span>
        ))}
    </div>
  );
};

export default ReviewCategory;
